import React from 'react';
import { Container, Paper, Typography, Button, Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

const SignupSuccess: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Container maxWidth="sm" sx={{ py: 8 }}>
      <Paper elevation={3} sx={{ p: 4, textAlign: 'center' }}>
        <CheckCircleOutlineIcon sx={{ fontSize: 64, color: 'success.main', mb: 2 }} />
        
        <Typography variant="h4" gutterBottom color="primary">
          Thank You for Signing Up!
        </Typography>
        
        <Typography variant="body1" paragraph sx={{ mb: 4 }}>
          Welcome to TBX HealthTech! Your account has been successfully created. Our TBX team will review your information and contact you shortly through your provided phone number.
        </Typography>

        <Typography variant="body1" paragraph sx={{ mb: 4 }}>
          Important Next Steps:
          <Box component="ul" sx={{ textAlign: 'left', mt: 2 }}>
            <li>Keep your phone nearby for our confirmation message</li>
            <li>Prepare your medical records if available</li>

          </Box>
        </Typography>

        <Button
          variant="contained"
          color="primary"
          size="large"
          onClick={() => navigate('/login')}
          sx={{ mt: 2 }}
        >
          Proceed to Login
        </Button>
      </Paper>
    </Container>
  );
};

export default SignupSuccess; 